/* 🤖 this file was generated by svg-to-ts */
export const mgcIconYSkewCuteFi: {
  name: 'y-skew-cute-fi';
  data: string;
} = {
  name: 'y-skew-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M9.427 3.485c-.597.043-1.312.188-1.733.351-.664.258-1.455.843-1.916 1.418-.327.408-.747 1.241-.999 1.986-.232.683-1.725 5.901-1.964 6.86-.348 1.4-.475 2.472-.378 3.2.201 1.515 1.175 2.559 2.759 2.959 1.049.264 1.86.3 6.804.3s5.755-.036 6.804-.3c1.411-.356 2.329-1.218 2.681-2.519.074-.273.087-.427.087-1.04.001-1.202-.146-1.854-1.407-6.26-.891-3.114-1.034-3.552-1.404-4.3-.439-.886-.917-1.414-1.765-1.948-.674-.425-1.409-.632-2.523-.71-.697-.049-4.351-.047-5.046.003"/></svg>`
};
